import React, { useEffect } from 'react';
import intl from '$intl';
import { IonContent } from '@ionic/react';
import { Formik } from 'formik';

import { PageWrapper } from '$gstyles/wrapper';
import { Button } from '$gcomponents/primitives';

import CouponModel from '$fbusiness/models/coupon';
import { FormSection } from '$gcomponents/reusables';
import { COUPON_FORM } from './couponForm';
import { input } from '$gbusiness/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { factoryActions } from '$fbusiness/redux/factory';
import { AppModel } from '$business/redux';
import Footer from '$gcomponents/widgets/footer';
import { getAccess, isAccessible } from '$fbusiness/helpers/util';

interface CouponDetailsProps {
  onClose: Function;
  coupon: CouponModel;
  currentState;
}

const CouponDetails: React.FC<CouponDetailsProps> = ({ coupon, onClose, currentState }) => {
  const dispatch = useDispatch();
  const ACCESS = getAccess(currentState);
  const isFinished = useSelector((state: AppModel) => state.factory.isFinished);

  useEffect(() => {
    if (!isFinished) return;
    dispatch(factoryActions.resetFinished());
    onClose();
  }, [isFinished, onClose, dispatch]);

  const onSubmit = (values) => {
    const { id } = coupon;
    dispatch(factoryActions.saveCoupon(id, values));
  };

  const validateForm = (values) => {
    return input.validateError(COUPON_FORM, values);
  };

  const {
    code,
    name,
    description,
    type,
    discount_value,
    min_order_amount,
    applies_to,
    start_date,
    end_date,
    max_redemptions,
    max_uses_per_customer,
    is_active,
  } = coupon;

  const canSave = isAccessible(
    coupon?.id ? ACCESS.ACTION.SETTING.COUPON.EDIT : ACCESS.ACTION.SETTING.COUPON.CREATE,
    currentState,
  );

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        code,
        name,
        description: description || '',
        type,
        discount_value,
        min_order_amount,
        applies_to,
        start_date,
        end_date,
        max_redemptions,
        max_uses_per_customer,
        is_active,
      }}
      validate={validateForm}
      onSubmit={(values) => {
        onSubmit(values);
      }}>
      {(formik) => (
        <>
          <IonContent>
            <PageWrapper>
              <FormSection FORM={COUPON_FORM} formik={formik} />
            </PageWrapper>
          </IonContent>
          <Footer justifyContent="center">
            <Button
              className="half"
              onClick={formik.handleSubmit}
              disabled={!(formik.isValid && formik.dirty) || !canSave}>
              {intl('BUTTON.SUBMIT')}
            </Button>
          </Footer>
        </>
      )}
    </Formik>
  );
};

export default CouponDetails;
